var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#2D6CDF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_51044)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9453 10.9453H13.0547V7.05469C13.0547 6.4722 12.5825 6 12 6C11.4175 6 10.9453 6.4722 10.9453 7.05469V10.9453H7.05469C6.4722 10.9453 6 11.4175 6 12C6 12.5825 6.4722 13.0547 7.05469 13.0547H10.9453V16.9453C10.9453 17.5278 11.4175 18 12 18C12.5825 18 13.0547 17.5278 13.0547 16.9453V13.0547H16.9453C17.5278 13.0547 18 12.5825 18 12C18 11.4175 17.5278 10.9453 16.9453 10.9453Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_51044"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/addIcon.9392e7dd5be45b1a0eb74b2f7f43b768.svg";
export { ForwardRef as ReactComponent };